<template>
    <div class="page-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="onBack">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">被护理人信息</span>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 表单内容 -->
        <div class="form-content">
            <!-- 被护理人信息（必填） -->
            <div class="section-title">被护理人信息（必填）</div>
            <div class="section-card">
                <!-- 姓名 -->
                <div class="form-item">
                    <span class="form-label">姓名</span>
                    <div class="form-value">
                        <input
                                class="form-input"
                                placeholder="请输入真实姓名"
                                v-model="name"
                        />
                    </div>
                </div>

                <!-- 性别 -->
                <div class="form-item" @click="onGenderTap">
                    <span class="form-label">性别</span>
                    <div class="form-value">
                        <span :class="gender ? 'value-span' : 'placeholder'">
                            {{ gender || "请选择性别" }}
                        </span>
                        <span class="arrow">></span>
                    </div>
                </div>

                <!-- 年龄 -->
                <div class="form-item">
                    <span class="form-label">年龄</span>
                    <div class="form-value">
                        <input
                                class="form-input"
                                type="number"
                                placeholder="请输入年龄"
                                v-model="age"
                        />
                    </div>
                </div>

                <!-- 联系电话 -->
                <div class="form-item">
                    <span class="form-label">联系电话</span>
                    <div class="form-value">
                        <input
                                class="form-input"
                                type="number"
                                placeholder="请输入联系电话"
                                v-model="phone"
                        />
                    </div>
                </div>

                <!-- 身份证号 -->
                <div class="form-item">
                    <span class="form-label">身份证号</span>
                    <div class="form-value">
                        <input
                                class="form-input"
                                placeholder="请输入身份证号"
                                v-model="idCard"
                        />
                    </div>
                </div>
            </div>

            <!-- 被护理人信息（必填） -->
            <div class="section-title">被护理人信息（必填）</div>
            <div class="section-card">
                <!-- 所患病种 -->
                <div class="form-item" @click="onDiseaseTap">
                    <span class="form-label">所患病种</span>
                    <div class="form-value">
                        <span :class="diseaseTypesspan ? 'value-span' : 'placeholder'">
                            {{ diseaseTypesspan || "请选择所患病种" }}
                        </span>
                        <span class="arrow">></span>
                    </div>
                </div>

                <!-- 身体状况 -->
                <div class="form-item" @click="onPhysicalTap">
                    <span class="form-label">身体状况</span>
                    <div class="form-value">
                        <span :class="physicalCondition ? 'value-span' : 'placeholder'">
                            {{ physicalCondition || "请选择身体状况" }}
                        </span>
                        <span class="arrow">></span>
                    </div>
                </div>

                <!-- 护工偏好 -->
                <div class="form-item" @click="onCaregiverTap">
                    <span class="form-label">护工偏好</span>
                    <div class="form-value">
                        <span :class="caregiverPreference ? 'value-span' : 'placeholder'">
                            {{ caregiverPreference || "请选择护工偏好" }}
                        </span>
                        <span class="arrow">></span>
                    </div>
                </div>
            </div>

            <!-- 家属信息（选填） -->
            <div class="section-title">家属信息（选填）</div>
            <div class="section-card">
                <!-- 家属姓名 -->
                <div class="form-item">
                    <span class="form-label">家属姓名</span>
                    <div class="form-value">
                        <input
                                class="form-input"
                                placeholder="请输入家属姓名"
                                v-model="familyMemberName"
                        />
                    </div>
                </div>

                <!-- 家属电话 -->
                <div class="form-item">
                    <span class="form-label">家属电话</span>
                    <div class="form-value">
                        <input
                                class="form-input"
                                type="number"
                                placeholder="请填写家属手机号码"
                                v-model="familyMemberPhone"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部确认按钮 -->
        <div class="bottom-bar">
            <button class="confirm-btn" @click="onSubmit">确认</button>
        </div>

        <!-- 性别选择弹窗 -->
        <div
                class="popup-mask"
                v-if="showGenderPopup"
                @click="onClosePopup"
        >
            <div class="popup-content" @click.stop>
                <div class="popup-title">选择性别</div>
                <div class="popup-options">
                    <div
                            class="popup-option"
                            :class="{ selected: gender === item }"
                            v-for="item in genderOptions"
                            :key="item"
                            @click="onGenderSelect(item)"
                    >
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 所患病种选择弹窗 -->
        <div
                class="popup-mask"
                v-if="showDiseasePopup"
                @click="onClosePopup"
        >
            <div class="popup-content" @click.stop>
                <div class="popup-header">
                    <span class="popup-title">选择所患病种（可多选）</span>
                    <span class="popup-confirm" @click="onConfirmDisease">确认</span>
                </div>
                <div class="popup-options">
                    <div
                            class="popup-option"
                            :class="{ selected: item.selected }"
                            v-for="item in diseaseOptions"
                            :key="item.name"
                            @click="onToggleDisease(item)"
                    >
                        <span>{{ item.name }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 身体状况选择弹窗 -->
        <div
                class="popup-mask"
                v-if="showPhysicalPopup"
                @click="onClosePopup"
        >
            <div class="popup-content" @click.stop>
                <div class="popup-title">选择身体状况</div>
                <div class="popup-options">
                    <div
                            class="popup-option"
                            :class="{ selected: physicalCondition === item }"
                            v-for="item in physicalOptions"
                            :key="item"
                            @click="onPhysicalSelect(item)"
                    >
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 护工偏好选择弹窗 -->
        <div
                class="popup-mask"
                v-if="showCaregiverPopup"
                @click="onClosePopup"
        >
            <div class="popup-content" @click.stop>
                <div class="popup-title">选择护工偏好</div>
                <div class="popup-options">
                    <div
                            class="popup-option"
                            :class="{ selected: caregiverPreference === item }"
                            v-for="item in caregiverOptions"
                            :key="item"
                            @click="onCaregiverSelect(item)"
                    >
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // 病种选项
    const DISEASE_OPTIONS = [
        "糖尿病",
        "高血脂",
        "高血压",
        "冠心病",
        "肺病",
        "骨科手术",
    ];
    // 护工偏好选项
    const CAREGIVER_OPTIONS = ["优先男护工", "优先女护工", "无特别要求"];
    // 身体状况选项
    const PHYSICAL_OPTIONS = ["自理", "半自理", "不能自理"];
    // 性别选项
    const GENDER_OPTIONS = ["男", "女"];

    export default {
        name: "patientForm",
        data() {
            return {
                mode: "add", // add 或 edit
                enterpriseId: "",
                patientId: "",

                // 表单数据
                name: "",
                gender: "",
                age: "",
                phone: "",
                idCard: "",
                diseaseTypes: [],
                diseaseTypesspan: "",
                physicalCondition: "",
                caregiverPreference: "",
                familyMemberName: "",
                familyMemberPhone: "",

                // 弹窗控制
                showDiseasePopup: false,
                showCaregiverPopup: false,
                showPhysicalPopup: false,
                showGenderPopup: false,

                // 选项数据
                diseaseOptions: DISEASE_OPTIONS.map((item) => ({
                    name: item,
                    selected: false,
                })),
                caregiverOptions: CAREGIVER_OPTIONS,
                physicalOptions: PHYSICAL_OPTIONS,
                genderOptions: GENDER_OPTIONS,

                // 临时选中的病种
                tempDiseaseTypes: [],
            };
        },
        created() {
            this.initPage();
        },
        methods: {
            initPage() {
                // 获取路由参数（Vue2 写法）
                const { enterpriseId, mode } = this.$route.query;
                this.enterpriseId = enterpriseId || "";
                this.mode = mode || "add";

                if (this.mode === "edit") {
                    this.loadPatientData();
                }
            },

            // 加载编辑数据
            loadPatientData() {
                const patientStr = localStorage.getItem('editPatient');
                const patient = patientStr ? JSON.parse(patientStr) : null;
                if (patient) {
                    const diseaseTypes = patient.diseaseTypes || [];
                    this.patientId = patient.id;
                    this.name = patient.name || "";
                    this.gender = patient.gender || "";
                    this.age = patient.age ? String(patient.age) : "";
                    this.phone = patient.phone || "";
                    this.idCard = patient.idCard || "";
                    this.diseaseTypes = diseaseTypes;
                    this.diseaseTypesspan = diseaseTypes.join("，");
                    this.physicalCondition = patient.physicalCondition || "";
                    this.caregiverPreference = patient.caregiverPreference || "";
                    this.familyMemberName = (patient.familyMember || {}).name || "";
                    this.familyMemberPhone = (patient.familyMember || {}).phone || "";
                    this.tempDiseaseTypes = diseaseTypes;
                }
            },

            // 性别弹窗
            onGenderTap() {
                this.showGenderPopup = true;
            },
            onGenderSelect(val) {
                this.gender = val;
                this.showGenderPopup = false;
            },

            // 病种弹窗
            onDiseaseTap() {
                this.tempDiseaseTypes = [...this.diseaseTypes];
                this.diseaseOptions = DISEASE_OPTIONS.map((item) => ({
                    name: item,
                    selected: this.tempDiseaseTypes.includes(item),
                }));
                this.showDiseasePopup = true;
            },
            onToggleDisease(item) {
                const index = this.tempDiseaseTypes.indexOf(item.name);
                if (index > -1) {
                    this.tempDiseaseTypes.splice(index, 1);
                } else {
                    this.tempDiseaseTypes.push(item.name);
                }
                this.diseaseOptions = this.diseaseOptions.map((i) => ({
                    name: i.name,
                    selected: this.tempDiseaseTypes.includes(i.name),
                }));
            },
            onConfirmDisease() {
                this.diseaseTypes = [...this.tempDiseaseTypes];
                this.diseaseTypesspan = this.diseaseTypes.join("，");
                this.showDiseasePopup = false;
            },

            // 身体状况
            onPhysicalTap() {
                this.showPhysicalPopup = true;
            },
            onPhysicalSelect(val) {
                this.physicalCondition = val;
                this.showPhysicalPopup = false;
            },

            // 护工偏好
            onCaregiverTap() {
                this.showCaregiverPopup = true;
            },
            onCaregiverSelect(val) {
                this.caregiverPreference = val;
                this.showCaregiverPopup = false;
            },

            // 关闭所有弹窗
            onClosePopup() {
                this.showDiseasePopup = false;
                this.showCaregiverPopup = false;
                this.showPhysicalPopup = false;
                this.showGenderPopup = false;
            },

            // 提交
            async onSubmit() {
                if (!this.name) {
                    this.$toast("请输入姓名");
                    return;
                }
                if (!this.gender) {
                    this.$toast("请选择性别");
                    return;
                }
                if (!this.age) {
                    this.$toast("请输入年龄");
                    return;
                }
                if (!this.phone) {
                    this.$toast("请输入联系电话");
                    return;
                }
                if (this.diseaseTypes.length === 0) {
                    this.$toast("请选择所患病种");
                    return;
                }
                if (!this.physicalCondition) {
                    this.$toast("请选择身体状况");
                    return;
                }
                if (!this.caregiverPreference) {
                    this.$toast("请选择护工偏好");
                    return;
                }

                const formData = {
                    enterpriseId: this.enterpriseId,
                    name: this.name,
                    gender: this.gender,
                    age: parseInt(this.age),
                    phone: this.phone,
                    idCard: this.idCard,
                    diseaseTypes: this.diseaseTypes,
                    physicalCondition: this.physicalCondition,
                    caregiverPreference: this.caregiverPreference,
                    familyMember: {
                        name: this.familyMemberName,
                        phone: this.familyMemberPhone,
                    },
                };

                try {
                    let res;
                    let url = ""
                    if (this.mode === "edit") {
                        url='/api-enterprise/caregiver/patient/update'
                        formData.id = this.patientId;
                    } else {
                        url='/api-enterprise/caregiver/patient/add'
                    }

                    this.$api.post(url, formData, response => {
                        if (response.data.result == "success") {
                            this.$toast.success(this.mode === "edit" ? "更新成功" : "添加成功");
                            setTimeout(() => {
                                this.$router.back();
                            }, 1500);
                        } else {
                            this.$toast(res.message || "操作失败");
                        }
                    })

                } catch (err) {
                    this.$loading.hide();
                    this.$toast("网络请求失败");
                    console.error("submit fail:", err);
                }
            },

            // 返回
            onBack() {
                this.$router.back();
            },
        },
    };
</script>

<style scoped>
    .page-container {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding-bottom: 80px;
    }

    /* 导航栏 */
    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    .nav-back {
        display: flex;
        align-items: center;
        gap: 2.5px;
        cursor: pointer;
    }

    .back-arrow {
        font-size: 16px;
        color: #07c160;
    }

    .back-text {
        font-size: 14px;
        color: #07c160;
    }

    .nav-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .nav-placeholder {
        width: 50px;
    }

    /* 表单内容 */
    .form-content {
        padding: 10px 0;
    }

    .section-title {
        font-size: 13px;
        color: #101010;
        padding: 10px 15px;
    }

    .section-card {
        background-color: #fff;
        margin: 0 12px;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    }

    .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        border-bottom: 1px solid #f0f0f0;
    }

    .form-item:last-child {
        border-bottom: none;
    }

    .form-label {
        font-size: 14px;
        color: #333;
        width: 80px;
    }

    .form-value {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .form-input {
        /* 去掉边框 */
        border: none;
        outline: none;
        background: transparent;
        /* 占位文字和输入文字都右对齐 */
        text-align: right;
        font-size: 14px;
        color: #333;
        width: 100%;
    }

    .form-input::placeholder {
        color: #999;
        /* 确保占位文字右对齐 */
        text-align: right;
    }

    .value-span {
        font-size: 14px;
        color: #333;
    }

    .placeholder {
        font-size: 14px;
        color: #999;
    }

    .arrow {
        margin-left: 5px;
        color: #999;
    }

    /* 底部操作区 */
    .bottom-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        padding: 10px 15px;
        /*padding-bottom: calc(10px + env(safe-area-inset-bottom));*/
        box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.05);
        z-index: 100;
    }

    .confirm-btn {
        display: block;
        padding: 0;
        margin: auto;
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: rgba(0, 184, 147, 0.72);
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-radius: 22px;
        border: none;
    }

    .confirm-btn::after {
        border: none;
    }

    /* 弹窗样式 */
    .popup-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        align-items: flex-end;
    }

    .popup-content {
        width: 100%;
        background-color: #fff;
        border-radius: 12px 12px 0 0;
        padding: 15px;
        /*padding-bottom: calc(15px + env(safe-area-inset-bottom));*/
    }

    .popup-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .popup-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 15px;
    }

    .popup-confirm {
        font-size: 14px;
        color: #07c160;
        margin-bottom: 15px;
    }

    .popup-options {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .popup-option {
        padding: 8px 15px;
        border-radius: 4px;
        border: 1px solid #ddd;
        font-size: 14px;
        color: #333;
    }

    .popup-option.selected {
        border-color: #07c160;
        background-color: #07c160;
        color: #fff;
    }
</style>
